import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SubscriptionPlanRecapComponent } from '~app/app/subscription/components/subscription-plan-recap/subscription-plan-recap.component';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'user-ads-creation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './user-ads-creation-dialog.component.html',
  styleUrl: './user-ads-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAdsCreationDialogComponent extends BaseComponent {
  protected _dialogRef = inject(MatDialogRef<SubscriptionPlanRecapComponent>);
  close(): void {
    this._dialogRef.close();
  }
}
